// based on https://getbootstrap.com/docs/4.1/layout/overview/#responsive-breakpoints

export default {
  Xl: '(min-width: 1200px)',
  Lg: '(min-width: 992px) and (max-width: 1199.98px)',
  Md: '(min-width: 768px) and (max-width: 991.98px)',
  Sm: '(min-width: 576px) and (max-width: 767.98px)',
  Xs: '(max-width: 575.98px)'
};



// WEBPACK FOOTER //
// ./src/lib/queries.js